export class QuantityTypeTemplateQuestion {
  constructor(
    public readonly id: string,
    public readonly order: number,
    public readonly type: "boolean"|"text"|"value"|"multi",
    public readonly question: string,
    public readonly should_export: boolean,
    public readonly exportName: string|null,
    public readonly pictureRequirements: {
      if_value: string|number|boolean|null
      is_required: boolean
    }[],
    // Value specific
    public readonly min: number|null,
    public readonly max: number|null,
    public readonly export_multiplier: number|null,
    public readonly export_decimals: number|null,
    public readonly export_unit: string|null,

    // Multi specific
    public readonly options: string[],
    public readonly includeOtherOption: boolean|null,
  ) {
  }

  static fromJson(json: any): QuantityTypeTemplateQuestion {
    return new QuantityTypeTemplateQuestion(
      json['id'],
      json['order'],
      json['type'],
      json['question'],
      json['should_export'],
      json['export_name'],
      json['picture_requirements'],
      json['min'],
      json['max'],
      json['export_multiplier'],
      json['export_decimals'],
      json['export_unit'],
      json['options'],
      json['include_other_option'],
    )
  }
}